const algolia = () => ({
  appId: process.env.REACT_APP_ALGOLIA_APP_ID,
  apiKey: process.env.REACT_APP_ALGOLIA_API_KEY,
  indexName: process.env.REACT_APP_ALGOLIA_INDEX || 'riivi-content'
});

export default algolia;
